import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Building2 } from "lucide-react";
import { format, parseISO } from "date-fns";

interface RegisteredCompaniesTableProps {
  data: { 
    name: string; 
    createdAt: string; 
    activeJobs: number;
  }[];
}

export function RegisteredCompaniesTable({ data }: RegisteredCompaniesTableProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Building2 className="h-5 w-5" />
          Empresas Cadastradas
        </CardTitle>
        <CardDescription>
          Lista de empresas registradas na plataforma ({data.length} {data.length === 1 ? 'empresa' : 'empresas'})
        </CardDescription>
      </CardHeader>
      <CardContent>
        {data.length === 0 ? (
          <p className="text-sm text-muted-foreground text-center py-4">
            Nenhuma empresa cadastrada ainda
          </p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nome da Empresa</TableHead>
                <TableHead>Data de Cadastro</TableHead>
                <TableHead className="text-right">Vagas Ativas</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((company, index) => (
                <TableRow key={index}>
                  <TableCell className="font-medium">{company.name}</TableCell>
                  <TableCell className="text-muted-foreground">
                    {format(parseISO(company.createdAt), 'dd/MM/yyyy')}
                  </TableCell>
                  <TableCell className="text-right">
                    <Badge 
                      variant={company.activeJobs > 0 ? "default" : "secondary"}
                      className={company.activeJobs > 0 ? "bg-green-500/10 text-green-600 hover:bg-green-500/20" : ""}
                    >
                      {company.activeJobs}
                    </Badge>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
